import { Label, Input, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Textarea } from '@creanizer/ui'
import type { SocietyInput } from '@creanizer/types'

interface BatchModeFormProps {
  input: SocietyInput
  onChange: (input: SocietyInput) => void
}

export function BatchModeForm({ input, onChange }: BatchModeFormProps) {
  const handleChange = (field: keyof SocietyInput, value: any) => {
    onChange({ ...input, [field]: value })
  }

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="numberOfSocieties">生成数（最大4）</Label>
        <Input
          id="numberOfSocieties"
          type="number"
          min={1}
          max={4}
          value={input.numberOfSocieties || 3}
          onChange={(e) => handleChange('numberOfSocieties', parseInt(e.target.value))}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="batchTheme">バッチテーマ（省略可）</Label>
        <Input
          id="batchTheme"
          value={input.batchTheme || ''}
          onChange={(e) => handleChange('batchTheme', e.target.value)}
          placeholder="関連する組織群のテーマ（例：同じ都市の組織、対立する派閥）"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="societyType">組織タイプ</Label>
          <Select value={input.societyType} onValueChange={(value) => handleChange('societyType', value)}>
            <SelectTrigger id="societyType">
              <SelectValue placeholder="ランダム" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="random">ランダム</SelectItem>
              <SelectItem value="government">政府・行政機関</SelectItem>
              <SelectItem value="military">軍事組織</SelectItem>
              <SelectItem value="mercenary">傭兵団</SelectItem>
              <SelectItem value="guild">ギルド・組合</SelectItem>
              <SelectItem value="merchant">商業組織</SelectItem>
              <SelectItem value="criminal">犯罪組織</SelectItem>
              <SelectItem value="religious">宗教組織</SelectItem>
              <SelectItem value="academic">学術機関</SelectItem>
              <SelectItem value="secret_society">秘密結社</SelectItem>
              <SelectItem value="adventurer_party">冒険者パーティー</SelectItem>
              <SelectItem value="noble_house">貴族家</SelectItem>
              <SelectItem value="cult">カルト教団</SelectItem>
              <SelectItem value="rebel">反乱軍・レジスタンス</SelectItem>
              <SelectItem value="group">グループ</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="genre">ジャンル</Label>
          <Select value={input.genre} onValueChange={(value) => handleChange('genre', value)}>
            <SelectTrigger id="genre">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="fantasy">ファンタジー</SelectItem>
              <SelectItem value="sf">SF</SelectItem>
              <SelectItem value="modern">現代</SelectItem>
              <SelectItem value="post_apocalypse">ポストアポカリプス</SelectItem>
              <SelectItem value="cyberpunk">サイバーパンク</SelectItem>
              <SelectItem value="steampunk">スチームパンク</SelectItem>
              <SelectItem value="mythology">神話</SelectItem>
              <SelectItem value="horror">ホラー</SelectItem>
              <SelectItem value="urban_fantasy">アーバンファンタジー</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="additionalSettings">追加設定（省略可）</Label>
        <Textarea
          id="additionalSettings"
          value={input.additionalSettings || ''}
          onChange={(e) => handleChange('additionalSettings', e.target.value)}
          placeholder="その他の詳細な設定や要望があれば入力してください"
          rows={3}
        />
      </div>

      <div className="p-4 bg-muted rounded-lg">
        <h4 className="font-semibold mb-2">📦 バッチモードについて</h4>
        <ul className="text-sm text-muted-foreground space-y-1">
          <li>• 複数の組織を一度に生成します（最大4組織）</li>
          <li>• テーマを指定すると、関連性のある組織群が生成されます</li>
          <li>• 各組織は独自の特徴を持ちながら、全体として統一感があります</li>
          <li>• 対立関係や協力関係なども自動的に設定されます</li>
        </ul>
      </div>
    </div>
  )
}